module.exports = __webpack_public_path__ + "static/shareWater3BG-ec04771f6cbaf95199a41b48b6894aa0.png";